
export const environment = 'network'

export const sysVersion='V6.20.43-260806'
//局域网配置
//export const environment = 'local'


